import { FormRow } from "../../common/hook-form";
import { useFormContext } from "react-hook-form";
import * as Inputs from "../../common/hook-form/index";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import * as authSelectors from "../../auth/authSelectors";
import { useChallenges } from "../../../service/api";
import { ChallengeType } from "../../../service/api-response/Challenges";
import { useHandleFetchError } from "../../../error-handler";

export const ChallengePrerequisiteSelector = () => {
  const { id } = useParams<{
    id: string;
  }>();

  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );

  const { register, clearErrors, formState } = useFormContext();
  const {
    data: challenges,
    isLoading: challengesIsLoading,
    error: listChallengesError,
  } = useChallenges(organizationKeyName);

  useHandleFetchError(listChallengesError);

  if (challengesIsLoading || !challenges) {
    return null;
  }

  const challengeids = challenges.map((c) => c.id);
  const distinctIds = [...new Set(challengeids)];
  const latestChallenges: ChallengeType[] = [];

  distinctIds.forEach((id) => {
    const group: ChallengeType[] = [];
    challenges.forEach((ch) => {
      if (ch.id === id) {
        group.push(ch);
      }
    });
    group.sort((a: ChallengeType, b: ChallengeType) => b.version - a.version);
    // We know the first element is the latest version. Need the latest even though it is same id as name can change
    latestChallenges.push(group[0]);
  });

  const challengesOptions = (latestChallenges || [])
    .filter((c) => c.id !== id)
    .map((c) => ({
      value: c.id,
      label: c.name,
    }));

  challengesOptions.unshift({
    label: "",
    value: "",
  });

  return (
    <FormRow>
      <Inputs.SelectFormField
        errors={formState.errors}
        register={register}
        label="Prerequisite challenge"
        name="prerequisiteChallengeId"
        helpText="Select the challenge the user has to complete to start this challenge"
        options={challengesOptions}
        clearErrors={clearErrors}
      />
    </FormRow>
  );
};
